
import { apolloClient } from 'apollo/client';
import React, { useEffect, useState } from 'react'
import updateUserMutation from 'utils/mutations/UpdateUser';

const useUpdateUnitSystem = (me) => {
  const [firstPageLoad, setFirstPageLoad] = useState(true);

  const changeUnitSystem = async () => {
    const userInstaceCode =
      me?.profile?.geographicInstance?.edges[0]?.node?.code;

    await apolloClient.mutate({
      mutation: updateUserMutation,
      variables: {
        input: {
          userId: me.id,
          unitSystem: userInstaceCode === "us" ? 1 : 0,
        },
      },
      refetchQueries: [
        "SinglePatternGeneralQuery",
        "SinglePatternBackingQuery",
        "MultiplePatternsQuery",
        "SinglePatternPDFQuery"
      ],
    })
  };

  useEffect(() => {
    if (me && firstPageLoad)
      changeUnitSystem().then(() => {
        setFirstPageLoad(false); // 👈 Ahora espera
      });
  }, [me]);
}

export default useUpdateUnitSystem